/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetTimecardsAndBreaksRequest} from '@cash-web/protos/squareup/timecards/timecards_service.pb'
import {GetTimecardsAndBreaksResponse} from '@cash-web/protos/squareup/timecards/timecards_service.pb'


export const getTimecardsAndBreaks = (request: GetTimecardsAndBreaksRequest, options?: CashRequestOptions) => post<GetTimecardsAndBreaksRequest, GetTimecardsAndBreaksResponse>("/proxy/services/squareup.timecards.PublicTimecardsService/GetTimecardsAndBreaks", request, {...options, rejectOnError: true })